import { render, staticRenderFns } from "./v-card-action.vue?vue&type=template&id=3ee8f562&"
import script from "./v-card-action.vue?vue&type=script&lang=js&"
export * from "./v-card-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports